export default [

    {
		path: '/profile',	name: 'Profile',
		meta: { requiresAuth: true, section: 'Profile' },
		component: () => import('@/views/account/Profile'),
    },
    {
		path: '/profile/update',	name: 'ProfileUpdate',
		meta: { requiresAuth: true, section: 'ProfileUpdate' },
		component: () => import('@/views/account/ProfileUpdate'),
    },
]

